import React, { Component } from 'react'
import { connect } from 'react-redux'
//import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {stReportsTableReady,rowsPerPageState,paginationState,previousFilterStartDate,previousFilterEndDate} from '../redux/streports'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
//import { SearchField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import * as Helpers from '../../../common/helpers'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/stReportsTable.css'



// import {Cities} from '../../../common/DropDowns/index'


import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'


function filterUnwantedData(sTReportsData) {
    let array = []
    if (sTReportsData && sTReportsData.data && sTReportsData.data.ticket_summary) {
        array = sTReportsData.data.ticket_summary
    }

    let newArray = []
    newArray.all_city=array.all_city
    let allCityArr=[]

    let cityData=Object.entries(array.city_wise);

    for (let i = 0; i < cityData.length; i++) {

        let countObj=[]
        let cityDataLevelDown=Object.entries(cityData[i][1])
        if(cityDataLevelDown.length>0){
            for (let j = 0; j < cityDataLevelDown.length; j++) {
                       countObj[j]=[]
                       countObj[j]={
                            "name":cityDataLevelDown[j][0],
                            "count":cityDataLevelDown[j][1]
                       }                  
            }            
        }else{
            countObj=[]
        }
        allCityArr[i]=[]
        allCityArr[i]={
            "type":cityData[i][0],
            "city":countObj
        }
    }


    newArray.city_wise=allCityArr 
    return newArray
}


class STReportsTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            sTReportsData: [],
            allCity:{},
            cityWise:[],
            query_datetime:"",
            bodyHeight: "0px",
            tableHeight: "0px",
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                'Yesterday': [moment().subtract(1, 'day'), moment().subtract(1, 'day')]
            },
            rowCount: 15,
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null

         
    }


    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(stReportsTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.ST_REPORTS_TABLE))
        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()


            let previousFilterStartDate=moment().format("YYYY-MM-DD")
            let previousFilterEndDate=moment().format("YYYY-MM-DD")

         if (this.props.streports && this.props.streports.previousFilterStartDate && this.props.streports.previousFilterStartDate!==undefined) {
            previousFilterStartDate=this.props.streports.previousFilterStartDate
         }
         if (this.props.streports && this.props.streports.previousFilterEndDate && this.props.streports.previousFilterEndDate!==undefined) {
            previousFilterEndDate=this.props.streports.previousFilterEndDate
         }

         this.setState({
              startDate:previousFilterStartDate,
              endDate:previousFilterEndDate
         },() => {
            this.getsTReportsData()
        });


        
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 80) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }


     onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {

                this.props.dispatch(previousFilterStartDate(api_start_date))
                this.props.dispatch(previousFilterEndDate(api_end_date))

                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                },() => {
                    this.getFilteredSTReportsList()

                })

                
            }
        }
    }
    
    getsTReportsData = () => {
        apiService.getsTReportsData(this.state.startDate,this.state.endDate)
            .then(sTReportsData => {
                if (sTReportsData && this.isComponentMounted) {
                    this.validateBuildNumber(sTReportsData)
                    if (sTReportsData.status === "SUCCESS") {
                        let array = filterUnwantedData(sTReportsData), pageNo = 1
                        if (this.props.streports && this.props.streports.previousPaginationValue) {
                            pageNo = this.props.streports.previousPaginationValue
                        }
                        this.setState({
                            allCity: array.all_city,
                            cityWise: array.city_wise,
                            page: pageNo,
                            query_datetime:sTReportsData.query_datetime
                        })
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: sTReportsData.reason ? sTReportsData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(stReportsTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(stReportsTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.streports && this.props.streports.previousRowsPerPageValue) {
            value = this.props.streports.previousRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

   
    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsPerPageState(value))
        this.dropUpManager()
    }

     renderLocation = (cell, row, enumObject, rowIndex,) => {
        
        let location=""
        
            location=<p>{row.work_location} - {row.city_name}</p>

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{location}</div>
        </div>)
    }



    renderCreatedFormat = (cell, row, enumObject, rowIndex,) => {
                let dateTemp="NA"

        if(row.created){
            dateTemp=Helpers.getDateTimeFormatForUTC(row.created)
        }
        
         
        return (<p>{dateTemp}</p>)
    }


    createCustomToolBar = props => {

        // let ticketDetailsFilename = "storeTickets_" + moment().format("MM/DD/YYYY") + "-" +
        //     moment().format("h:mm:ss") + ".csv"

        let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }


        let firstComponent = ''

        
            firstComponent = <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>


        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 header-div-margins">
            

                    {firstComponent}

                    <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredSTReportsList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                    </div>
                    <div className="col-md-5 col-sm-12 col-xs-12 div-margins" style={{float: "right",textAlign:"right",fontSize: "1.2em",color: "red"}}>

                    Report as on  : {this.state.query_datetime}

                    </div>
                   
                   
                </div>
            </div>
        )
    }




    
    createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.sTReportsData.length>=(this.props.streports.previousPaginationValue*this.props.streports.previousRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.streports.previousPaginationValue*this.props.streports.previousRowsPerPageValue)-this.props.streports.previousRowsPerPageValue+1} to {this.props.streports.previousPaginationValue*this.props.streports.previousRowsPerPageValue} of {this.state.sTReportsData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.streports.previousPaginationValue*this.props.streports.previousRowsPerPageValue)-this.props.streports.previousRowsPerPageValue+1} to {this.state.sTReportsData.length} of {this.state.sTReportsData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

    getFilteredSTReportsList = () => {
       
        this.props.dispatch(stReportsTableReady(false))
        this.getsTReportsData()
       
    }

   

    

    resetFilterValues = () => {
        this.props.dispatch(stReportsTableReady(false))
        this.setState({
            startDate: moment().format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD")
        },() => {
            this.props.dispatch(previousFilterStartDate(moment().format("YYYY-MM-DD")))
            this.props.dispatch(previousFilterEndDate(moment().format("YYYY-MM-DD")))

        this.getsTReportsData();
        });
    }


     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationState(page))
        this.setState({
            page: page
        })
    }

    
   
    render() {
       
        return (

        <div className="react-bs-table-container">
   {this.createCustomToolBar()}
   <div className="st-reports-table" style={{ marginBottom: '0px',background: "white",padding: "1%" , height: this.state.bodyHeight,overflow: "auto" }}>
   <Dialog ref={el =>
   this.dialog = el} />
   <div className="row" style={{padding: "0% 2%"}} >
      <div className="col-sm-12">
         <h4 className="report-header">Overall Summary</h4>
      </div>
      {(() => {
      if(this.state.allCity!==undefined && this.state.allCity!==null && this.state.allCity!==""){
      return (
      <div className="col-sm-12">
      <table className="table table-bordered table-hover table-striped overall">
         <thead>
            <tr>
               <th></th>
               <th>Total Disabled</th>
               <th colspan="2">Completed</th>
               <th>New</th>
               <th>Assigned</th>
               <th>Hold</th>
               <th>Closed</th>
            </tr>
         </thead>
         <tbody>


            {(() => {
            if(this.state.allCity.today!==undefined && this.state.allCity.today!==null && this.state.allCity.today!==""){
            return (
            <tr>
               <td>TODAY</td>
               <td>{this.state.allCity.today['TOTAL_COUNT']}</td>
               <td>{this.state.allCity.today['COMPLETED_COUNT']}</td>
               <td>{this.state.allCity.today['COMPLETED_PERCENTAGE']}</td>
               <td>{this.state.allCity.today['NEW']}</td>
               <td>{this.state.allCity.today['ASSIGNED']}</td>
               <td>{this.state.allCity.today['HOLD']}</td>
               <td>{this.state.allCity.today['CLOSED']}</td>
            </tr>
            )
            }
            })()}


            {(() => {
            if(this.state.allCity.current_week!==undefined && this.state.allCity.current_week!==null && this.state.allCity.current_week!==""){
            return (
            <tr>
               <td>THIS WEEK</td>
               <td>{this.state.allCity.current_week['TOTAL_COUNT']}</td>
               <td>{this.state.allCity.current_week['COMPLETED_COUNT']}</td>
               <td>{this.state.allCity.current_week['COMPLETED_PERCENTAGE']}</td>
               <td>{this.state.allCity.current_week['NEW']}</td>
               <td>{this.state.allCity.current_week['ASSIGNED']}</td>
               <td>{this.state.allCity.current_week['HOLD']}</td>
               <td>{this.state.allCity.current_week['CLOSED']}</td>
            </tr>
            )
            }
            })()}


            {(() => {
            if(this.state.allCity.current_month!==undefined && this.state.allCity.current_month!==null && this.state.allCity.current_month!==""){
            return (
            <tr>
               <td>THIS MONTH</td>
               <td>{this.state.allCity.current_month['TOTAL_COUNT']}</td>
               <td>{this.state.allCity.current_month['COMPLETED_COUNT']}</td>
               <td>{this.state.allCity.current_month['COMPLETED_PERCENTAGE']}</td>
               <td>{this.state.allCity.current_month['NEW']}</td>
               <td>{this.state.allCity.current_month['ASSIGNED']}</td>
               <td>{this.state.allCity.current_month['HOLD']}</td>
               <td>{this.state.allCity.current_month['CLOSED']}</td>
            </tr>
            )
            }
            })()}
            {(() => {
            if(this.state.allCity.custom!==undefined && this.state.allCity.custom!==null && this.state.allCity.custom!==""){
            return (
            <tr>
            <td>
               {(() => {
                   if(this.state.startDate===this.state.endDate){
                       return (
                           <span>
                                {this.state.startDate}
                           </span>
                       )
                       }else{
                       return (
                           <span>
                                {this.state.startDate} to {this.state.endDate}
                           </span>
                       )
                   }
               })()}
            </td>
               <td>{this.state.allCity.custom['TOTAL_COUNT']}</td>
               <td>{this.state.allCity.custom['COMPLETED_COUNT']}</td>
               <td>{this.state.allCity.custom['COMPLETED_PERCENTAGE']}</td>
               <td>{this.state.allCity.custom['NEW']}</td>
               <td>{this.state.allCity.custom['ASSIGNED']}</td>
               <td>{this.state.allCity.custom['HOLD']}</td>
               <td>{this.state.allCity.custom['CLOSED']}</td>
            </tr>
            )
            }
            })()}

         </tbody>
      </table>
      </div>
      )
      }
      })()}
   </div>

  
<div className="row" style={{padding: "0% 2%"}}>
      <div className="col-sm-12">
         <h4 className="report-header">City Wise Summary</h4>
      </div>
      {(() => {

        if(this.state.cityWise.length>0){
              return (
              <div className="col-sm-12">
                {this.state.cityWise.map((item, index) => (
                      <table className="table table-bordered table-hover table-striped cityWise">
                         <thead>
                            <tr>
                                <th>
                                   {(() => {
                                       if(this.state.startDate===this.state.endDate && this.state.cityWise[index].type.toUpperCase().replace("_"," ")==="CUSTOM"){
                                           return (
                                               <span>
                                                    {this.state.startDate}
                                               </span>
                                           )
                                           }else if(this.state.startDate!==this.state.endDate && this.state.cityWise[index].type.toUpperCase().replace("_"," ")==="CUSTOM"){
                                           return (
                                               <span>
                                                    {this.state.startDate} to {this.state.endDate}
                                               </span>
                                           )
                                        }else{
                                            return (
                                               <span>
                                                    {this.state.cityWise[index].type.toUpperCase().replace("_"," ")}
                                               </span>
                                           )
                                        }
                                   })()}


                               </th>
                               <th>Total Disabled</th>

                                {(() => {

                         if(this.state.cityWise[index].city.length>0){
                            return (
                                <th colspan="2">Completed</th>
                            )
                        }else{
                            return (
                                <th >Completed</th>
                            )
                        }
                         })()}


                               <th>New</th>
                               <th>Assigned</th>
                               <th>Hold</th>
                               <th>Closed</th>
                            </tr>
                         </thead>
                           

                         {(() => {

                         if(this.state.cityWise[index].city.length>0){
                            return (
                                  <tbody> 
                                 {this.state.cityWise[index].city.map((item2, index2) => (
                                    <tr>
                                     <td>{this.state.cityWise[index].city[index2].name}</td> 
                                     <td>
                                        {
                                         parseInt(parseInt(this.state.cityWise[index].city[index2].count['NEW'],10) ? parseInt(this.state.cityWise[index].city[index2].count['NEW'],10) : 0,10)   

                                        + parseInt(parseInt(this.state.cityWise[index].city[index2].count['ASSIGNED'],10) ? parseInt(this.state.cityWise[index].city[index2].count['ASSIGNED'],10) : 0,10) 

                                        + parseInt(parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) ? parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) : 0,10)

                                        + parseInt(parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) ? parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) : 0,10)  
                                        }
                                    </td>

                                     <td>
                                        {
                                         parseInt(parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10)  ? parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) : 0,10)   
                                        +  parseInt(parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) ? parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) : 0,10)   
                                        }
                                    </td>
                                     <td>{ 
                                        
                                        (parseFloat((
                                            (
                                            parseInt(parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10)  ? parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) : 0,10)   
                                            +  parseInt(parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) ? parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) : 0,10)
                                            )

                                            /

                                            (parseInt(parseInt(this.state.cityWise[index].city[index2].count['NEW'],10) ? parseInt(this.state.cityWise[index].city[index2].count['NEW'],10) : 0,10)   

                                            + parseInt(parseInt(this.state.cityWise[index].city[index2].count['ASSIGNED'],10) ? parseInt(this.state.cityWise[index].city[index2].count['ASSIGNED'],10) : 0,10) 

                                            + parseInt(parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) ? parseInt(this.state.cityWise[index].city[index2].count['HOLD'],10) : 0,10)

                                            + parseInt(parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) ? parseInt(this.state.cityWise[index].city[index2].count['CLOSED'],10) : 0,10) )
                                        )*100).toFixed(2))+"%"

                                         }</td> 

                                     <td>{this.state.cityWise[index].city[index2].count['NEW'] ? this.state.cityWise[index].city[index2].count['NEW'] : 0}</td>  
                                     <td>{this.state.cityWise[index].city[index2].count['ASSIGNED'] ? this.state.cityWise[index].city[index2].count['ASSIGNED'] : 0}</td>  
                                     <td>{this.state.cityWise[index].city[index2].count['HOLD'] ? this.state.cityWise[index].city[index2].count['HOLD'] : 0}</td>  
                                     <td>{this.state.cityWise[index].city[index2].count['CLOSED'] ? this.state.cityWise[index].city[index2].count['CLOSED'] : 0}</td>  

                                      
                                     </tr>
                                 ))}
                               </tbody>
                            )
                         }else{
                            return(
                             <tbody> 
                                <tr><td colspan="8">No records.</td></tr></tbody>
                            )
                         }

                         })()}

                           
                          
                         
                      </table>   
                  ))}

                  </div>
               )
           }

      })()}

   </div>



</div>


</div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        streports: state.streports
    }
}

export default connect(mapStateToProps)(withRouter(STReportsTable))


// WEBPACK FOOTER //
// ./src/modules/ST Reports/Components/STReportsTable.js